import {FormService} from '../services'
import {bindLoading} from './index';

export default {
    namespaced: true,
    state: {
        selectedForm: undefined
    },

    mutations: {
        saveSelectedForm(current, form){
            current.selectedForm = {...form};
        }
    },
    actions: {
        async getFormAction({dispatch, commit}, id) {
            await bindLoading(commit, async () => commit('saveSelectedForm', await FormService.getForm(id)), 'form')
        },

        
    }
}